import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { handleResponse } from 'APIPackage/MainModule/common/handleResponse';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { ISystemInoperability } from '../interfaces/ISystemInoperability';
import { ISystemInoperabilityResponse } from '../interfaces/ISystemInoperabilityResponse';

export async function fetchSystemInoperabilityList(
  sort?: string,
  pageNumber?: number,
): Promise<ISystemInoperabilityResponse> {
  const paramsPrefix = sort || typeof pageNumber === 'number' ? '?' : '';
  const params = sort ? `order=${sort}` : '';
  const page = pageNumber !== undefined ? `page=${pageNumber}` : '';

  return fetch(
    `${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/system-inoperability${paramsPrefix}${page}&${params}&size=9`,
    {
      method: 'GET',
      credentials: 'include',
    },
  ).then(handleResponse);
}

export async function addSystemInoperabilityRecord(formData: ISystemInoperability[]): Promise<ISystemInoperability[]> {
  return fetch(`${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/system-inoperability`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  }).then(handleResponse);
}
